import * as React from 'react';
import { compose, setDisplayName } from 'recompose';
import { translate } from 'react-i18next';
import { TranslateProps } from 'util/i18n';
import { Select } from 'ui/shared/Select';

export type OwnProps = {
    id: string;
    value: string;
    onChange: React.ChangeEventHandler<HTMLSelectElement>;
    disabled: boolean;
};

const RawMonthPicker = ({ id, value, onChange, disabled, t }: OwnProps & TranslateProps) =>
    <Select
        id={ id }
        value={ value }
        onChange={ onChange }
        disabled={ disabled }
    >
        <option value="January">{ t('January') }</option>
        <option value="February">{ t('February') }</option>
        <option value="March">{ t('March') }</option>
        <option value="April">{ t('April') }</option>
        <option value="May">{ t('May') }</option>
        <option value="June">{ t('June') }</option>
        <option value="July">{ t('July') }</option>
        <option value="August">{ t('August') }</option>
        <option value="September">{ t('September') }</option>
        <option value="October">{ t('October') }</option>
        <option value="November">{ t('November') }</option>
        <option value="December">{ t('December') }</option>
    </Select>
;

export const MonthPicker = compose<OwnProps & TranslateProps, OwnProps>(
    setDisplayName('MonthPicker'),
    translate(),
)(RawMonthPicker);



// WEBPACK FOOTER //
// ./src/ui/pages/designer/sections/schedule/runOnSchedule/recurrence/MonthPicker.tsx